export default __webpack_public_path__ + "static/logo.cmf-1ff26caf35b5989335ee695c22c202fb.png";